const getQuerySSR = (query: string | string[] | undefined) => {
  if (!query) return undefined;

  if (Array.isArray(query)) {
    return query[0];
  }

  return query;
};

export default getQuerySSR;
